import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[appNumbersOnly]',
  standalone: true
})
export class NumbersOnlyDirective {

  constructor(
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {

    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'Home',
      'End',
      'ArrowLeft',
      'ArrowRight'
    ];

    // Permite teclas de navegação
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Permite Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (
      (event.ctrlKey || event.metaKey) &&
      ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())
    ) {
      return;
    }

    // Permite somente dígitos de 0 a 9
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input')
  onInput(): void {
    const input = this.elementRef.nativeElement;

    const originalValue = input.value;
    const sanitizedValue = originalValue.replace(/\D/g, '');

    if (originalValue !== sanitizedValue) {
      input.value = sanitizedValue;

      input.dispatchEvent(
        new Event('input', { bubbles: true })
      );
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {

    const pastedText =
      event.clipboardData?.getData('text') ?? '';

    if (!/^\d+$/.test(pastedText)) {
      event.preventDefault();

      const numericText = pastedText.replace(/\D/g, '');

      const input = this.elementRef.nativeElement;
      const start = input.selectionStart ?? input.value.length;
      const end = input.selectionEnd ?? input.value.length;

      input.setRangeText(
        numericText,
        start,
        end,
        'end'
      );

      input.dispatchEvent(
        new Event('input', { bubbles: true })
      );
    }
  }
}